<template>
  <div>
    <b-row align-h="center">
      <b-col lg="8" class="my-5 check-account">
        <p class="check-account-text">
          {{ $t("takeAmoment") }} {{ getTrackDownloaded }}
          {{ $t("takeAmomentdownloads") }}
        </p>
      </b-col>
    </b-row>
    <b-row align-h="center" class="px-3">
      <b-col lg="9" class="check-account-content p-lg-5 pt-3">
        <div class="check-account-image">
          <img
            :src="user.imageUrl ? user.imageUrl : user && user.user && user.user.imageUrl ? user.user.imageUrl : 'assets/images/empty-image.svg'"
            class="user-image"
          />
          <h3 class="user-name my-4">{{ getUserName }}</h3>
        </div>
        <account-content-list
          imageSrc="assets/images/icons/download-icon.svg"
          :dataName="$t('download')"
          :dataValue="'' + getTrackDownloaded"
        ></account-content-list>
        <account-content-list
          imageSrc="assets/images/icons/icon-booster.svg"
          :dataName="$t('booster')"
          :dataValue="'' + getUserBooster"
        ></account-content-list>
        <account-content-list
          imageSrc="assets/images/icons/icon-coin.svg"
          :dataName="$t('coins')"
          :dataValue="'' + getUserCoins"
        ></account-content-list>
        <account-content-list
          :dataName="$t('connectWith')"
          :dataValue="capitalizeFirstLetter(user.connectMethod || user.method)"
        ></account-content-list>
        <account-content-list
          :dataName="$t('email')"
          :dataValue="getUserEmail"
          listClass="user-email"
        ></account-content-list>
        <account-content-list
          :dataName="$t('userId')"
          :dataValue="getUserId"
        ></account-content-list>
        <account-content-list dataName="" dataValue=""></account-content-list>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-5 pb-5">
      <b-col lg="9" md="9" sm="9" cols="12" class="px-lg-0 mt-3">
        <div class="cancel">
          <div
            class="cancel-delete-account-btn px-5"
            v-b-modal.modal-keep-account
          >
            <modal
              :action="account"
              modalId="modal-keep-account"
              :title="$t('keepAccountModalTitle')"
              :subTitle="$t('keepAccountModalSubTitle')"
            ></modal>
            <span class="cancel-delete-account-label my-1">{{
              $t("keepAccount")
            }}</span>
          </div>
        </div>
        <div class="continue mt-lg-0 mt-md-3 mt-sm-3 mt-3">
          <div
            class="continue-delete-account-btn px-4 "
            ref="btnShow"
            @click="confirmationAccount()"
          >
            <modal
              :action="account"
              modalId="modal-delete-account"
              :title="$t('deleteAccountModalTitle')"
              :subTitle="$t('deleteAccountModalSubTitle')"
            ></modal>
            <span class="continue-delete-account-label my-1">
              {{ $t("continueDeleteAccount") }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { pageNavigation } from "../../../mixins/navigation";
import AccountContentList from "../../Account/AccountContentList.vue";
import Modal from "../../Modal.vue";

export default {
  name: "DeleteAccountStepTow",
  components: { AccountContentList, Modal },
  mixins: [pageNavigation],
  data() {
    return {
      user: {}
    };
  },
  mounted() {
    const token = localStorage.getItem("token") || null;
    if (!token) {
      window.location = "https://home.trebel.io";
    }
    this.user = JSON.parse(localStorage.getItem("userInfo"))
  },
  computed: {
    getUserName() {
      // eslint-disable-next-line no-nested-ternary
      if (this.user.firstName && this.user.lastName) {
        return `${this.user.firstName} ${this.user.lastName}`;
      }
      if (this.user.firstName || this.user.lastName) {
        return this.user.firstName || this.user.lastName;
      }
      return this.user.email;
    },
    getUserEmail() {
      return this.user.email || this.user.user.email
    },
    getUserId() {
      return this.user.userId || this.user.user.userId
    },
    getTrackDownloaded() {
      return this.user && this.user.trackDownloaded ?
              this.user.trackDownloaded :
              this.user.counts && this.user.counts.downloads ?
                  this.user.counts.downloads :
                  '0'
    },
    getUserBooster() {
      return this.user && this.user.booster ?
            this.user.booster :
            this.user.balance && this.user.balance.booster ?
                this.user.balance.booster :
                '0'
    },
    getUserCoins() {
      return this.user && this.user.coins ?
          this.user.coins :
          this.user.balance && this.user.balance.coins ?
              this.user.balance.coins :
              '0'
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    confirmationAccount() {
      const token = localStorage.getItem("token") || null;
      if (!token) {
        this.$root.$emit("bv::show::modal", "modal-delete-account", "#btnShow");
      } else {
        this.$router.push({ query: { q: "confirmation" } }).catch(() => {});
      }
    }
  }
};
</script>

<style scoped></style>
